import React from 'react'
import { Button } from 'react-bootstrap'
import { ChevronLeft, ChevronRight } from 'lucide-react'

interface NavigationControlsProps {
  onPrevious: () => void
  onNext: () => void
  onSubmit: () => void
  hasAnnotations: boolean
  showConfirmDialog: () => void
  submitLabel?: string
}

const NavigationControls: React.FC<NavigationControlsProps> = ({
  onPrevious,
  onNext,
  onSubmit,
  hasAnnotations,
  showConfirmDialog,
  submitLabel,
}) => {
  return (
    <div className="tool-group mb-3">
      <h6 className="text-white mt-1 small">Image Navigation</h6>
      <div className="d-grid gap-2">
        <div className="d-flex gap-2">
          <Button variant="outline-secondary" className="w-50" onClick={onPrevious}>
            <ChevronLeft size={18} className="me-2" />
            Prev
          </Button>
          <Button variant="outline-secondary" className="w-50" onClick={onNext}>
            Next
            <ChevronRight size={18} className="ms-2" />
          </Button>
        </div>
        <Button
          variant="success"
          onClick={hasAnnotations ? onSubmit : showConfirmDialog}
          className="w-100"
        >
          {submitLabel || 'Submit Annotations'}
        </Button>
      </div>
    </div>
  )
}

export default NavigationControls
